import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Loading } from "../../../components/Loading/Loading";
import { Toast } from "primereact/toast";
// import { FooterButtonCenter } from "../../../components/FooterButton/FooterButton"; //FooterButton,
import { dataUserSession } from "../../../utilities/dataSession";
import P302Overview from "./P302Overview";
import P302List from "./P302List";
import "../../../components/DataTable/DataTable.css";
import P302Map from "./P302Map";
import P302Chart from "./P302Chart";
import P302Info from "./P302Info";
import P302Chart2 from "./P302Chart2";
import P302List2 from "./P302List2";
import P302List3 from "./P302List3";
import P302List4 from "./P302List4";
import { P302Dashboard, P302DataList, P302GetDataChart_1, P302GetDataChart_2 } from "../../../service/300/P302Service";
import { formatDateNum_TH } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { Button } from "primereact/button";

export default function P302() {

    const history = useHistory();
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);


    /**
     * Search All
     * DashBoard
     * DataList_1
     */
    const [searchData, setSearchData] = useState({
        "branchCode": dataUserSession() ? dataUserSession().userBranchCode:"",
        "budgetType": "",
        "userId": dataUserSession() ? dataUserSession().userId : "",
    });
    const [dataDashboard, setDataDashboard] = useState({
        "totalContract": 0,
        "totalPipeLength": 0,
        "totalAmount": 0,
        "pendingAmount": 0,
        "supervisorCount":0
    });
    const [dataTable, setDataTable] = useState([]);

    /**
     * Search Info Contract
     * DataInfo Contract
     */
    const [searchInfo, setSearchInfo] = useState({
        "contractNo": "",
        "userId": dataUserSession() ? dataUserSession().userId : "",
    });
    const [dataInfo, setDataInfo] = useState([]);
    const [dataTableA, setDataTableA] = useState([]);
    const [dataTableB, setDataTableB] = useState([]);
    const [dataTableC, setDataTableC] = useState([]);

    const [sentChart, setSentChart] = useState({
        "branchCode": dataUserSession() ? dataUserSession().userBranchCode:"",
        "userId": dataUserSession() ? dataUserSession().userId : "",
    });
    const [dataChart1, setDataChart1] = useState({
        data : [],
        seriesList : [],
        valList : []
    });
    const [dataChart2, setDataChart2] = useState([]);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (dataUserSession()) {
            // console.log('dataUserSession() ',dataUserSession());
            if (history.location.state && history.location.state.branchCode) {
                setSearchData({
                    ...searchData,
                    ...history.location.state,
                });

                setSentChart({
                    ...sentChart,
                    ...history.location.state,
                })

                setSearchInfo({
                    ...searchInfo,
                    ...history.location.state,
                })
            }

        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {

        onP302Dashboard();
        onP302DataList();
        onP302GetDataChart_1();
        onP302GetDataChart_2();
    }, [searchData,searchInfo]);

    const onP302Dashboard = () => {
        P302Dashboard(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res != undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        if(index === 1){
                            setDataDashboard({
                                "totalContract": element.totalContract,
                                "totalPipeLength": element.totalPipeLength,
                                "totalAmount": element.totalAmount,
                                "pendingWithdraw": element.pendingWithdraw,
                                "supervisorCount" : element.supervisorCount
                            })
                        }

                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP302DataList = () => {
        P302DataList(searchInfo).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let tempTbA = [];
                    let tempTbB = [];
                    let tempTbC = [];
                    res.forEach((element) => {
                        if(element.recordType === "1"){
                            temp.push({
                                ...element,
                            });
                        }else if(element.recordType === "2"){
                            tempTbA.push({
                                ...element,
                            });
                        }else if(element.recordType === "3"){
                            tempTbB.push({
                                ...element,
                            });

                        }else if(element.recordType === "4"){
                            tempTbC.push({
                                ...element,
                            });

                        }
                    });
                    setDataTableA (tempTbA)
                    setDataTableB(tempTbB)
                    setDataTableC(tempTbC)
                    setDataInfo(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP302GetDataChart_1 = () => {
        setLoading(true);
        P302GetDataChart_1(sentChart).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    let seriesList = [];
                    let valList = [];
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });

                        if(element.seriesName && element.seriesName !== ''){ seriesList.push(element.seriesName) }
                        if(element.seriesAmount && element.seriesAmount !== ''){ valList.push(element.seriesAmount) }

                        index++;
                    });
                    setDataChart1({data : temp, seriesList,valList });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const onP302GetDataChart_2 = () => {
        setLoading(true);
        P302GetDataChart_2(sentChart).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let seriesList = [];
                    let valList1 = [];
                    let valList2 = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });


                            seriesList.push(formatDateNum_TH(element.dateSeries))
                            valList1.push(element.planAmount)
                            valList2.push(element.actualAmount)

                        index++;
                    });
                    setDataChart2({data : temp, seriesList,valList1,valList2 });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err)
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const onRowClick = (e) =>{
        if(e && e.data){
            setSearchInfo({
                ...searchInfo,
                contractNo: e.data.contractNo
            })
        }
    }

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err ={errData} setErr ={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2>รายละเอียดสัญญา</h2>
                        <hr/> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-field p-col-12 p-md-6">

                                <Button
                                    className="p-button-secondary p-button btn-long-top-responsive"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ display: 'flex',marginBottom : '10px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => {
                                        history.push({
                                            pathname: '301',
                                            state: {
                                                branchCode : searchData.branchCode
                                            },
                                        });
                                    }}
                                />

                            </div>
                        </div>
                        <P302Overview dataDashboard={dataDashboard} searchData={searchData} />
                        <br />
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-12">
                                {/* <div className="card" > */}
                                    {/* <div className="p-grid  p-fluid"> */}
                                        <P302Map data={searchInfo} />
                                    {/* </div> */}
                                {/* </div> */}
                            </div>
                        </div>

                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-12">
                                <P302List dataTable={dataTable} onRowClick={onRowClick}  />
                            </div>
                        </div>

                        <hr/>
                        <P302Info data={dataInfo} />

                        <div className="p-grid p-fluid" style={{marginTop:20}}>
                            <div className="p-col-12 p-lg-6">
                                <h4><b>กรรมการ</b></h4>
                                <P302List2 dataTable={dataTableA} />
                            </div>
                            <div className="p-col-12 p-lg-6">
                                <h4><b>ผู้ควบคุมงาน</b></h4>
                                <P302List3 dataTable={dataTableB} />
                            </div>

                        </div>

                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-lg-6">
                                <P302List4 dataTable={dataTableC}  />
                            </div>
                            <div className="p-col-12 p-lg-6">
                                <P302Chart data={dataChart1} />
                            </div>

                        </div>

                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-lg-1"></div>
                            <div className="p-col-12 p-lg-10">
                                <div className="card">
                                   <P302Chart2 data={dataChart2} />

                                   {/* <P302Chart3 /> */}
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
